var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAffiliation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66667 18.2222C9.66667 18.6518 10.0149 19 10.4444 19H13.5556C13.9851 19 14.3333 18.6518 14.3333 18.2222V14.3333L18.2222 14.3333C18.6518 14.3333 19 13.9851 19 13.5556V10.4444C19 10.0149 18.6518 9.66667 18.2222 9.66667H14.3333L14.3333 5.77778C14.3333 5.34822 13.9851 5 13.5556 5H10.4444C10.0149 5 9.66667 5.34822 9.66667 5.77778V9.66667H5.77778C5.34822 9.66667 5 10.0149 5 10.4444V13.5556C5 13.9851 5.34822 14.3333 5.77778 14.3333H9.66667V18.2222Z",
    stroke: "#B152F5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAffiliation);
export default __webpack_public_path__ + "static/media/icon-affiliation.64e77d87bb66db500dbc50ecfbffef22.svg";
export { ForwardRef as ReactComponent };